import type { FC, PropsWithChildren } from "react"
import { useRef } from "react"

import type { Point2d } from "@logic/lib/2d"
import type { DraggableEvent } from "react-draggable"
import { DraggableCore } from "react-draggable"
import { useRecoilState } from "recoil"

import { activityState } from "../../state/activity"
import { useMoveAll } from "../../state/elements/transactions/move/moveAll"

type MoveProps = PropsWithChildren<{
  position: Point2d
  onDrag(position: Point2d): void
  nodeRef: React.RefObject<HTMLElement>
}>
export const Move: FC<MoveProps> = ({ children, position, onDrag, nodeRef }) => {
  const [activity, setActivity] = useRecoilState(activityState)
  const canMove = activity === null || activity === `moving`
  const displacement = useRef<Point2d>({ x: 0, y: 0 })
  const moveAll = useMoveAll()

  const updatePosition = (e: DraggableEvent) => {
    if (canMove) {
      if (e instanceof MouseEvent) {
        const { movementX, movementY } = e
        const hasMoved = movementX || movementY
        if (hasMoved) {
          displacement.current.y += movementY
          displacement.current.x += movementX
          if (!activity) setActivity(`moving`)
        }
        onDrag({
          x: movementX + position.x,
          y: movementY + position.y,
        })
      }
    }
  }

  return (
    <>
      <DraggableCore
        nodeRef={nodeRef}
        onDrag={updatePosition}
        onStop={() => {
          if (displacement.current.x || displacement.current.y) {
            moveAll()
            setActivity(null)
          }
          displacement.current.x = 0
          displacement.current.y = 0
        }}
      >
        {children}
      </DraggableCore>
    </>
  )
}
